<template>
  <div class="analysis-table-page col-block">
    <div class="option-container row-block">
      <div class="data-block row-block">
        <template v-if="conditions.filters.product">
          <div><b>品項：</b>{{ getFilterTitle('product') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="conditions.filters.country">
          <div><b>目標市場：</b>{{ getFilterTitle('country') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="dataType === 'country' && conditions.filters.year">
          <div><b>數據年份：</b>{{ getFilterTitle('year') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="dataType === 'year' && country">
          <div><b>{{ { competitiveness: '競爭國家', attraction: '市場國家', toolcompetitiveness: '競爭國家', toolattraction: '市場國家' }[analysisType] }}：</b>{{ { competitiveness: country.country_name, attraction: country.partner_name, toolcompetitiveness: country.country_name, toolattraction: country.partner_name }[analysisType] }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <div class="row-block">
          <b>原始數值</b>
          <div class="block white"></div>
        </div>
        <div :style="{ width: '50px' }"></div>
        <div class="row-block">
          <b>{{ { country: '標準化分數', year: '該指標標準化分數之年度世界排名' }[dataType] }}</b>
          <div class="block" :class="[{ country: 'blue', year: 'yellow' }[dataType]]"></div>
        </div>
      </div>
      <div class="button-block row-block">
        <template v-if="rolePermission(['advance', 'admin'])">
          <button type="button" name="button" class="main-button option-button update" @click="e => downloadData()">
            <span>原始數據下載</span>
          </button>
          <div :style="{ width: '15px' }"></div>
        </template>
        <button type="button" name="button" class="main-button option-button update" @click="e => exportTable()">
          <span>匯出表格</span>
        </button>
      </div>
    </div>
    <div class="content-container" :style="{ flex: 1 }">
      <div class="table-block">
        <analysisTable
          :dataType="dataType"
          :datas="tableDatas || []"
          :option="tableOption"
          :init="selectedDatas"
          :onSelected="selected => onSelected(selected)"
          @countryOnClick="data => countryOnClick(data)"
          @reportOnClick="data => reportOnClick(data)"
        ></analysisTable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { postAccessLog } from '../../api'
import analysisTable from '../tool/analysisTable'
import userPermission from '../../mixins/userPermission'
import toastMethods from '../../mixins/toastMethods'
import { sortData, toPriceString, downloadFile } from '../../constants/global/util'

export default {
  components: {
    analysisTable
  },
  mixins: [
    userPermission,
    toastMethods
  ],
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: () => null
    },
    curSelectedDatas: {
      type: Array,
      required: true
    },
    datas: {
      type: Array,
      required: true
    },
    reportCountrys: {
      type: Array,
      default: () => ([])
    },
    state: {
      type: String,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selectedDatas: null
    }
  },
  created () {
    this.selectedDatas = this.tableDatas
  },
  computed: {
    analysisType () {
      return this.$route.name
    },
    tableDatas () {
      let tableDatas = this.datas
      tableDatas = {
        country: {
          competitiveness: sortData(sortData(tableDatas.filter(data => data.addition.partner_import_country_value !== null), data => data.addition.partner_import_country_value, 'desc').slice(0, 5), 'total_standardization_order'),
          attraction: sortData(tableDatas, 'total_standardization_order').slice(0, 20),
          toolcompetitiveness: sortData(sortData(tableDatas.filter(data => data.addition.partner_import_country_value !== null), data => data.addition.partner_import_country_value, 'desc').slice(0, 5), 'total_standardization_order'),
          toolattraction: sortData(tableDatas, 'total_standardization_order').slice(0, 20)
        },
        year: {
          competitiveness: tableDatas,
          attraction: tableDatas,
          toolcompetitiveness: tableDatas,
          toolattraction: tableDatas
        }
      }[this.dataType][this.analysisType]
      if (['country'].includes(this.dataType)) {
        if (['competitiveness', 'toolcompetitiveness'].includes(this.analysisType)) {
          let taiwan = this.datas.find(data => data.country_name === '台灣')
          if (taiwan) {
            let datas = sortData(this.datas.filter(data => data.addition.partner_import_country_value !== null), [data => data.addition.partner_import_country_value, data => data.country_name === '台灣' ? 0 : 1], 'desc')
            taiwan.display_description = '<b>' + this.getFilterTitle('country').replace(/\(.*\)$/, '') + '</b> 進口該品項之進口值，' + (taiwan.addition.partner_import_country_value !== 0 ? taiwan.addition.partner_import_country_value ? '台灣排在第<b>' + (datas.indexOf(taiwan) + 1) + '</b>名' : '沒有來自台灣' : '台灣為０') + '。(排名與數值皆根據ITC提供之資料，若需詳細數值可參考其他網站)'
            !tableDatas.includes(taiwan) && tableDatas.push(taiwan)
          }
        }
        tableDatas = tableDatas.map(data => {
          let standardization = this.tableOption.contents.reduce((s, c) => ({
            ...s,
            [c.value]: this.getStandardizationPoint(tableDatas, data, c)
          }), {})
          data.display_standardization = standardization
          data.display_total_standardization = Object.values(standardization).reduce((s, c) => s + c, 0)
          data.hasReport = this.reportCountrys.includes({ competitiveness: data.country_code, attraction: data.partner_code, toolcompetitiveness: data.country_code, toolattraction: data.partner_code }[this.analysisType])
          return data
        })
      } else if (this.dataType === 'year') {
        tableDatas = tableDatas.map(data => {
          data.display_standardization = {}
          data.display_total_standardization = 0
          return data
        })
      }
      tableDatas = sortData(tableDatas, [data => (this.selectedDatas || []).includes(data) ? 1 : -1, { country: 'display_total_standardization', year: 'year' }[this.dataType]], ['desc', 'desc'], true)
      this.$emit('allDatas', tableDatas)
      return tableDatas
    },
    // static
    tableOption () {
      return {
        competitiveness: {
          maskWidth: 491.5,
          index: {
            width: 88
          },
          country: {
            title: '競爭國家',
            name: 'country_name',
            subName: 'country_iso_name',
            width: 330
          },
          year: {
            title: '數據年份',
            name: 'year',
            width: 330
          },
          contents: [
            {
              title: [
                '產量(公噸)'
              ],
              value: 'production_quantity',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '單位面積產量',
                '(百克/公頃)'
              ],
              value: 'yield',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '生產者價格',
                '(美元/公噸)'
              ],
              value: 'producer_price',
              standardization: {
                type: 'negative'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '進口單價',
                '(美元/公斤)'
              ],
              description: {
                title: '進口單價計算公式',
                content: '目標市場國進口競爭國之產品進口值 / 目標市場國進口競爭國之產品進口量'
              },
              value: 'import_price',
              standardization: {
                type: 'negative'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                'RCA'
              ],
              description: {
                title: '顯示性比較利益RCA公式',
                content: '(競爭國出口產品至目標市場國總出口值/全球出口產品至目標市場總出口值)/(競爭國出口水果(蔬菜)至目標市場總出口值/全球出口水果(蔬菜)至目標市場總出口值)'
              },
              value: 'RCA',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                'TII'
              ],
              description: {
                title: '貿易密集度TII公式',
                content: '(目標市場進口競爭國之產品總進口值/目標市場國進口全球之產品總進口值)/[競爭國出口全球之產品總出口值/(產品全球總出口值-目標市場國出口全球之產品總出口值)]'
              },
              value: 'TII',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '市場距離',
                '(公里)'
              ],
              value: 'distance',
              standardization: {
                type: 'negative'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            }
          ]
        },
        attraction: {
          maskWidth: 491.5,
          index: {
            width: 28
          },
          country: {
            title: '國家',
            name: 'partner_name',
            subName: 'partner_iso_name',
            width: 330
          },
          year: {
            title: '數據年份',
            name: 'year',
            width: 330
          },
          contents: [
            {
              title: [
                '產量(公噸)'
              ],
              value: 'production_quantity',
              standardization: {
                type: 'negative'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '出口值',
                '(千美元)'
              ],
              value: 'export_value',
              standardization: {
                type: 'negative'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '進口值',
                '(千美元)'
              ],
              value: 'import_value',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '市場規模',
                '(千美元)'
              ],
              description: {
                title: '市場規模計算公式',
                content: '(目標市場國之產品產量 * 目標市場國之產品生產者價格) + 目標市場國之產品總進口值 - 目標市場國之產品總出口值'
              },
              value: 'market_size',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '進口市場',
                '成長趨勢(%)'
              ],
              description: {
                title: '進口市場成長趨勢計算公式',
                content: '(目標市場國 本年度之產品總進口值 - 目標市場國 去年度之產品總進口值) / 目標市場國 去年度之產品總進口值'
              },
              value: 'import_market_growth_trend',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                'TSI'
              ],
              description: {
                title: '貿易專業化指數TSI的公式',
                content: '(目標市場國之產品總出口值 - 目標市場國之產品總進口值) / (目標市場國之產品總出口值 + 目標市場國之產品總進口值)'
              },
              value: 'TSI',
              standardization: {
                type: 'negative',
                max: 1,
                min: -1
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '市場距離',
                '(公里)'
              ],
              value: 'distance',
              standardization: {
                type: 'negative'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '全球貿易市場',
                '佔有率(%)'
              ],
              description: {
                title: '全球貿易市場佔有率計算公式',
                content: '目標市場國之產品進口值 / 全球之產品進口值'
              },
              value: 'market_share',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '平均每人',
                'GDP(美元)'
              ],
              value: 'GDP',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '人口數'
              ],
              value: 'total_population',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '市場成長',
                '相對強度(%)'
              ],
              description: {
                title: '市場成長相對強度計算公式',
                content: '[(今年目標市場國之產品進口值-5年前目標市場國之產品進口值)/(5年前目標市場國之產品進口值)] - [(今年全球之產品進口值-5年前全球之產品進口值)/(5年前全球之產品進口值)]'
              },
              value: 'market_growth_intensity',
              standardization: {
                type: 'positive',
                max: 15,
                min: -15
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '進口市場',
                '表現(%)'
              ],
              description: {
                title: '進口市場表現計算公式',
                content: '(目標市場國之產品進口值/全球之產品進口值) - (台灣之產品出口至目標市場國之出口值/台灣之產品總出口值)'
              },
              value: 'market_performance',
              standardization: {
                type: 'positive',
                max: 5,
                min: 0
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '市場開放',
                '程度(%)'
              ],
              alert: {
                title: '注意！',
                content: '因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
              },
              value: 'market_openness',
              standardization: {
                type: 'positive',
                max: 5,
                min: 30
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '市場相對',
                '優惠關稅(%)'
              ],
              description: {
                title: '市場相對優惠關稅',
                content: '目標市場國前五大進口國產品之平均關稅率 - 台灣至目標市場國之產品關稅率'
              },
              alert: {
                title: '注意！',
                content: '因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
              },
              value: 'market_preferential_tariff',
              standardization: {
                type: 'positive',
                max: 10,
                min: -10
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            }
          ]
        },
        toolcompetitiveness: {
          maskWidth: 491.5,
          index: {
            width: 88
          },
          country: {
            title: '競爭國家',
            name: 'country_name',
            subName: 'country_iso_name',
            width: 330
          },
          year: {
            title: '數據年份',
            name: 'year',
            width: 330
          },
          contents: [
            {
              title: [
                '進口單價 (美元)'
              ],
              description: {
                title: '進口單價計算公式',
                content: '目標市場國進口競爭國之產品進口值 / 目標市場國進口競爭國之產品進口量'
              },
              value: 'import_price',
              standardization: {
                type: 'negative'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                'RCA'
              ],
              description: {
                title: '顯示性比較利益RCA公式',
                content: '(競爭國出口產品至目標市場國總出口值/全球出口產品至目標市場總出口值)/(競爭國出口水果(蔬菜)至目標市場總出口值/全球出口水果(蔬菜)至目標市場總出口值)'
              },
              value: 'RCA',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                'TII'
              ],
              description: {
                title: '貿易密集度TII公式',
                content: '(目標市場進口競爭國之產品總進口值/目標市場國進口全球之產品總進口值)/[競爭國出口全球之產品總出口值/(產品全球總出口值-目標市場國出口全球之產品總出口值)]'
              },
              value: 'TII',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            }
          ]
        },
        toolattraction: {
          maskWidth: 491.5,
          index: {
            width: 28
          },
          country: {
            title: '國家',
            name: 'partner_name',
            subName: 'partner_iso_name',
            width: 330
          },
          year: {
            title: '數據年份',
            name: 'year',
            width: 330
          },
          contents: [
            {
              title: [
                '出口值',
                '(千美元)'
              ],
              value: 'export_value',
              standardization: {
                type: 'negative'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '進口值',
                '(千美元)'
              ],
              value: 'import_value',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '進口市場',
                '成長趨勢(%)'
              ],
              description: {
                title: '進口市場成長趨勢計算公式',
                content: '(目標市場國 本年度之產品總進口值 - 目標市場國 去年度之產品總進口值) / 目標市場國 去年度之產品總進口值'
              },
              value: 'import_market_growth_trend',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                'TSI'
              ],
              description: {
                title: '貿易專業化指數TSI的公式',
                content: '(目標市場國之產品總出口值 - 目標市場國之產品總進口值) / (目標市場國之產品總出口值 + 目標市場國之產品總進口值)'
              },
              value: 'TSI',
              standardization: {
                type: 'negative',
                max: 1,
                min: -1
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '全球貿易市場',
                '佔有率(%)'
              ],
              description: {
                title: '全球貿易市場佔有率計算公式',
                content: '目標市場國之產品進口值 / 全球之產品進口值'
              },
              value: 'market_share',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '平均每人',
                'GDP(美元)'
              ],
              value: 'GDP',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                'GNI',
                '(美元)'
              ],
              value: 'GNI',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '農業人口',
                '比率(%)'
              ],
              value: 'agricultural_population_proportion',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '農業人',
                '口比率',
                '趨勢(%)'
              ],
              description: {
                title: '農業人口比率趨勢計算公式',
                content: ''
              },
              value: 'agricultural_population_proportion_trend',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '耕地面積',
                '(平方公里)'
              ],
              value: 'cultivated_area',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '平均農業人口',
                '耕地面積',
                '(平方公里/人)'
              ],
              description: {
                title: '平均農業人耕地面積口計算公式',
                content: ''
              },
              value: 'average_agricultural_population_cultivated_area',
              standardization: {
                type: 'positive'
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '市場成長',
                '相對強度(%)'
              ],
              description: {
                title: '市場成長相對強度計算公式',
                content: '[(今年目標市場國之產品進口值-5年前目標市場國之產品進口值)/(5年前目標市場國之產品進口值)] - [(今年全球之產品進口值-5年前全球之產品進口值)/(5年前全球之產品進口值)]'
              },
              value: 'market_growth_intensity',
              standardization: {
                type: 'positive',
                max: 15,
                min: -15
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '進口市場',
                '表現(%)'
              ],
              description: {
                title: '進口市場表現計算公式',
                content: '(目標市場國之產品進口值/全球之產品進口值) - (台灣之產品出口至目標市場國之出口值/台灣之產品總出口值)'
              },
              value: 'market_performance',
              standardization: {
                type: 'positive',
                max: 5,
                min: 0
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '市場開放',
                '程度(%)'
              ],
              alert: {
                title: '注意！',
                content: '因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
              },
              value: 'market_openness',
              standardization: {
                type: 'positive',
                max: 5,
                min: 30
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            },
            {
              title: [
                '市場相對',
                '優惠關稅(%)'
              ],
              description: {
                title: '市場相對優惠關稅',
                content: '目標市場國前五大進口國產品之平均關稅率 - 台灣至目標市場國之產品關稅率'
              },
              alert: {
                title: '注意！',
                content: '因ITC關稅資料僅有最新年度之資料，並無歷年資料，因此各年度均以最新年度之關稅率作為分析數據之依據。'
              },
              value: 'market_preferential_tariff',
              standardization: {
                type: 'positive',
                max: 10,
                min: -10
              },
              display: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) }[this.dataType] : 'n/a',
              subDisplay: value => value || value === 0 ? { country: toPriceString(value.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')), year: value }[this.dataType] : 'n/a'
            }
          ]
        }
      }[this.analysisType]
    }
  },
  watch: {
    'datas' () {
      this.selectedDatas = [...this.tableDatas]
    },
    'tableDatas' () {
      this.$emit('dataChange', this.tableDatas.filter(data => this.selectedDatas.includes(data)))
    },
    'curSelectedDatas' (nv) {
      if (nv.length !== this.selectedDatas.length) {
        this.selectedDatas = [...nv]
      }
    },
    'selectedDatas' () {
      this.$emit('dataChange', this.tableDatas.filter(data => this.selectedDatas.includes(data)))
    }
  },
  methods: {
    ...mapActions([
      'setModalAction'
    ]),
    onSelected (selected) {
      this.selectedDatas = selected
    },
    countryOnClick (data, tab) {
      this.setModalAction({
        action: 'analysis',
        width: '1400px',
        height: 'calc(100% - 40px)',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          country: data,
          tab: tab,
          filterOptions: this.filterOptions,
          conditions: this.conditions
        }
      })
    },
    reportOnClick (data) {
      this.countryOnClick(data, 'report')
    },
    getFilterTitle (value) {
      if (!this.conditions.filters[value]) {
        return ''
      }
      return this.filterOptions.filters.find(filter => filter.value === value).options.find(option => option.value === this.conditions.filters[value]).title
    },
    getCountryTitle () {
      if (!this.country) {
        return ''
      }
      return { competitiveness: this.country.country_name, attraction: this.country.partner_name, toolcompetitiveness: this.country.country_name, toolattraction: this.country.partner_name }[this.analysisType]
    },
    getStandardizationPoint (allData, data, option) {
      let max = option.standardization.max || Math.max.apply(null, allData.map(data => data[option.value]).filter(value => value || value === 0))
      let min = option.standardization.min || Math.min.apply(null, allData.map(data => data[option.value]).filter(value => value || value === 0))
      let value =
        data[option.value] > Math.max(max, min) ? Math.max(max, min)
        : data[option.value] < Math.min(max, min) ? Math.min(max, min)
        : data[option.value]
      return (
        !data[option.value] && data[option.value] !== 0 ? 0
        : option.standardization.type === 'positive' ? 1 + (max === min ? 0 : 4 * ((value - min) / (max - min)))
        : option.standardization.type === 'negative' ? 5 - (max === min ? 0 : 4 * ((value - min) / (max - min)))
        : 0
      ) * (this.conditions.weightings[option.value].active ? this.conditions.weightings[option.value].value : 0)
    },
    async downloadData () {
      let dataOptions = {
        competitiveness: {
          ...({
            country: {
              '競爭國家': 'country_name'
            },
            year: {
              '數據年份': 'year'
            }
          }[this.dataType]),
          '產量(公噸)': 'production_quantity',
          '單位面積產量(百克/公頃)': 'yield',
          '生產者價格(美元)': 'producer_price',
          '進口單價(美元/公斤)': 'import_price',
          'RCA': 'RCA',
          'TII': 'TII',
          '市場距離(公里)': 'distance',
          '產量標準化分數': ['standardization', 'production_quantity'],
          '單位面積產量標準化分數': ['standardization', 'yield'],
          '生產者價格標準化分數': ['standardization', 'producer_price'],
          '進口單價標準化分數': ['standardization', 'import_price'],
          'RCA標準化分數': ['standardization', 'RCA'],
          'TII標準化分數': ['standardization', 'TII'],
          '市場距離標準化分數': ['standardization', 'distance'],
          '標準化分數總計': 'total_standardization',
          '標準化分數之世界排名': 'total_standardization_order',
          '目標市場國進口競爭國之產品進口值(千美元)': ['addition', 'partner_import_country_value'],
          '目標市場國進口競爭國之產品進口量': ['addition', 'partner_import_country_quantity'],
          '目標市場國進口競爭國之產品進口量單位': ['addition', 'partner_import_country_quantity_unit'],
          '目標市場國進口世界之產品進口值(千美元)': ['addition', 'partner_import_world_value'],
          '競爭國出口世界之產品出口值(千美元)': ['addition', 'country_export_world_value'],
          '世界之產品出口值(千美元)': ['addition', 'world_export_world_value'],
          '目標市場國出口世界之產品出口值(千美元)': ['addition', 'partner_export_world_value'],
          '競爭國出口目標市場國之產品出口值(千美元)': ['addition', 'country_export_partner_value'],
          '世界出口目標市場國之產品出口值(千美元)': ['addition', 'world_export_partner_value'],
          '競爭國出口目標市場國之水果/蔬菜出口值(千美元)': ['addition', 'class_country_export_partner_value'],
          '世界出口目標市場國之水果/蔬菜出口值(千美元)': ['addition', 'class_world_export_partner_value'],
          '競爭國出口目標市場國之產品出口量': ['addition', 'country_export_partner_quantity'],
          '競爭國出口目標市場國之產品出口量單位': ['addition', 'country_export_partner_quantity_unit'],
          '目標市場國出口世界之產品出口量': ['addition', 'partner_export_world_quantity'],
          '目標市場國出口世界之產品出口量單位': ['addition', 'partner_export_world_quantity_unit'],
          '世界出口目標市場國之產品出口量(公噸)': ['addition', 'world_export_partner_quantity'],
          '競爭國出口世界之產品出口量': ['addition', 'country_export_world_quantity'],
          '競爭國出口世界之產品出口量單位': ['addition', 'country_export_world_quantity_unit'],
          '目標市場國進口世界之產品進口量': ['addition', 'partner_import_world_quantity'],
          '目標市場國進口世界之產品進口量單位': ['addition', 'partner_import_world_quantity_unit'],
          '世界出口目標市場國之水果/蔬菜總出口量(公噸)': ['addition', 'class_world_export_partner_quantity'],
          '競爭國出口目標市場國之水果/蔬菜總出口量': ['addition', 'class_country_export_partner_quantity'],
          '競爭國出口目標市場國之水果/蔬菜總出口量單位': ['addition', 'class_country_export_partner_quantity_unit']
        },
        attraction: {
          ...({
            country: {
              '市場國家': 'partner_name'
            },
            year: {
              '數據年份': 'year'
            }
          }[this.dataType]),
          '產量(公噸)': 'production_quantity',
          '出口值(千美元)': 'export_value',
          '進口值(千美元)': 'import_value',
          '市場規模(千美元)': 'market_size',
          '進口市場成長趨勢(%)': 'import_market_growth_trend',
          'TSI': 'TSI',
          '市場距離(公里)': 'distance',
          '佔全球貿易市場佔有率(%)': 'market_share',
          '平均每人GDP(美元)': 'GDP',
          '人口數': 'total_population',
          '市場成長相對強度(%)': 'market_growth_intensity',
          '進口市場表現(%)': 'market_performance',
          '市場開放程度(%)': 'market_openness',
          '市場相對優惠關稅(%)': 'market_preferential_tariff',
          '產量標準化分數': ['standardization', 'production_quantity'],
          '出口值標準化分數': ['standardization', 'export_value'],
          '進口值標準化分數': ['standardization', 'import_value'],
          '市場規模標準化分數': ['standardization', 'market_size'],
          '進口市場成長趨勢標準化分數': ['standardization', 'import_market_growth_trend'],
          'TSI標準化分數': ['standardization', 'TSI'],
          '市場距離標準化分數': ['standardization', 'distance'],
          '佔全球貿易市場佔有率標準化分數': ['standardization', 'market_share'],
          '平均每人GDP標準化分數': ['standardization', 'GDP'],
          '人口數標準化分數': ['standardization', 'total_population'],
          '市場成長相對強度標準化分數': ['standardization', 'market_growth_intensity'],
          '進口市場表現標準化分數': ['standardization', 'market_performance'],
          '市場開放程度標準化分數': ['standardization', 'market_openness'],
          '市場相對優惠關稅標準化分數': ['standardization', 'market_preferential_tariff'],
          '標準化分數總計': 'total_standardization',
          '標準化分數之世界排名': 'total_standardization_order',
          '目標市場國之產品產量(公噸)': 'production_quantity',
          '目標市場國之產品生產者價格(美元)': ['addition', 'producer_price'],
          '目標市場國之產品進口值(千美元)': ['addition', 'partner_import_world_value'],
          '目標市場國之產品出口值(千美元)': ['addition', 'partner_export_world_value'],
          '目標市場國之產品前一年進口值(千美元)': ['addition', 'last_year_import_value'],
          '世界之產品進口值(千美元)': ['addition', 'world_import_world_value'],
          '目標市場國之產品五年前進口值(千美元)': ['addition', 'last_5_year_partner_import_world_value'],
          '世界之產品五年前進口值(千美元)': ['addition', 'last_5_year_world_import_world_value'],
          '台灣出口目標市場國之產品出口值(千美元)': ['addition', 'taiwan_export_partner_value'],
          '台灣之產品出口值(千美元)': ['addition', 'taiwan_export_world_value'],
          '目標市場國之產品第一大進口國關稅(%)': ['addition', 'top_5_tariff', 0, data => data ? data.chinese_name + ':' + data.tariff : 'n/a'],
          '目標市場國之產品第二大進口國關稅(%)': ['addition', 'top_5_tariff', 1, data => data ? data.chinese_name + ':' + data.tariff : 'n/a'],
          '目標市場國之產品第三大進口國關稅(%)': ['addition', 'top_5_tariff', 2, data => data ? data.chinese_name + ':' + data.tariff : 'n/a'],
          '目標市場國之產品第四大進口國關稅(%)': ['addition', 'top_5_tariff', 3, data => data ? data.chinese_name + ':' + data.tariff : 'n/a'],
          '目標市場國之產品第五大進口國關稅(%)': ['addition', 'top_5_tariff', 4, data => data ? data.chinese_name + ':' + data.tariff : 'n/a'],
          '目標市場國對台灣之產品關稅': ['addition', 'partner_taiwan_tariff'],
          '目標市場國之產品出口量': ['addition', 'partner_export_world_quantity'],
          '目標市場國之產品出口量單位': ['addition', 'partner_export_world_quantity_unit'],
          '目標市場國之產品進口量': ['addition', 'partner_import_world_quantity'],
          '目標市場國之產品進口量單位': ['addition', 'partner_import_world_quantity_unit'],
          '世界之產品進口量(公噸)': ['addition', 'world_import_world_quantity'],
          '世界之產品出口值(千美元)': ['addition', 'world_export_world_value'],
          '世界之產品出口量(公噸)': ['addition', 'world_export_world_quantity']
        },
        toolcompetitiveness: {
          ...({
            country: {
              '競爭國家': 'country_name'
            },
            year: {
              '數據年份': 'year'
            }
          }[this.dataType]),
          '產量(公噸)': 'production_quantity',
          '進口單價(美元/公斤)': 'import_price',
          'RCA': 'RCA',
          'TII': 'TII',
          '進口單價標準化分數': ['standardization', 'import_price'],
          'RCA標準化分數': ['standardization', 'RCA'],
          'TII標準化分數': ['standardization', 'TII'],
          '標準化分數總計': 'total_standardization',
          '標準化分數之世界排名': 'total_standardization_order',
          '目標市場國進口競爭國之產品進口值(千美元)': ['addition', 'partner_import_country_value'],
          '目標市場國進口競爭國之產品進口量': ['addition', 'partner_import_country_quantity'],
          '目標市場國進口競爭國之產品進口量單位': ['addition', 'partner_import_country_quantity_unit'],
          '目標市場國進口世界之產品進口值(千美元)': ['addition', 'partner_import_world_value'],
          '競爭國出口世界之產品出口值(千美元)': ['addition', 'country_export_world_value'],
          '世界之產品出口值(千美元)': ['addition', 'world_export_world_value'],
          '目標市場國出口世界之產品出口值(千美元)': ['addition', 'partner_export_world_value'],
          '競爭國出口目標市場國之產品出口值(千美元)': ['addition', 'country_export_partner_value'],
          '世界出口目標市場國之產品出口值(千美元)': ['addition', 'world_export_partner_value'],
          '競爭國出口目標市場國之農機分類出口值(千美元)': ['addition', 'class_country_export_partner_value'],
          '世界出口目標市場國之農機分類出口值(千美元)': ['addition', 'class_world_export_partner_value'],
          '競爭國出口目標市場國之產品出口量': ['addition', 'country_export_partner_quantity'],
          '競爭國出口目標市場國之產品出口量單位': ['addition', 'country_export_partner_quantity_unit'],
          '目標市場國出口世界之產品出口量': ['addition', 'partner_export_world_quantity'],
          '目標市場國出口世界之產品出口量單位': ['addition', 'partner_export_world_quantity_unit'],
          '世界出口目標市場國之產品出口量(公噸)': ['addition', 'world_export_partner_quantity'],
          '競爭國出口世界之產品出口量': ['addition', 'country_export_world_quantity'],
          '競爭國出口世界之產品出口量單位': ['addition', 'country_export_world_quantity_unit'],
          '目標市場國進口世界之產品進口量': ['addition', 'partner_import_world_quantity'],
          '目標市場國進口世界之產品進口量單位': ['addition', 'partner_import_world_quantity_unit'],
          '世界之產品出口量 (公噸)': ['addition', 'world_export_world_quantity'],
          '世界出口目標市場國之農機分類總出口量(公噸)': ['addition', 'class_world_export_partner_quantity'],
          '競爭國出口目標市場國之農機分類總出口量': ['addition', 'class_country_export_partner_quantity'],
          '競爭國出口目標市場國之農機分類總出口量單位': ['addition', 'class_country_export_partner_quantity_unit']
        },
        toolattraction: {
          ...({
            country: {
              '市場國家': 'partner_name'
            },
            year: {
              '數據年份': 'year'
            }
          }[this.dataType]),
          '出口值(千美元)': 'export_value',
          '進口值(千美元)': 'import_value',
          '進口市場成長趨勢(%)': 'import_market_growth_trend',
          'TSI': 'TSI',
          '佔全球貿易市場佔有率(%)': 'market_share',
          '平均每人GDP(美元)': 'GDP',
          'GNI(美元)': 'GNI',
          '農業人口比率(%)': 'agricultural_population_proportion',
          '農業人口比率趨勢': 'agricultural_population_proportion_trend',
          '耕地面積(平方公里)': 'cultivated_area',
          '平均農業人口耕地面積(平方公里/人)': 'average_agricultural_population_cultivated_area',
          '市場成長相對強度(%)': 'market_growth_intensity',
          '進口市場表現(%)': 'market_performance',
          '市場開放程度(%)': 'market_openness',
          '市場相對優惠關稅(%)': 'market_preferential_tariff',
          '出口值標準化分數': ['standardization', 'export_value'],
          '進口值標準化分數': ['standardization', 'import_value'],
          '進口市場成長趨勢標準化分數': ['standardization', 'import_market_growth_trend'],
          'TSI標準化分數': ['standardization', 'TSI'],
          '佔全球貿易市場佔有率標準化分數': ['standardization', 'market_share'],
          '平均每人GDP標準化分數': ['standardization', 'GDP'],
          'GNI標準化分數': ['standardization', 'GNI'],
          '農業人口比率標準化分數': ['standardization', 'agricultural_population_proportion'],
          '農業人口比率趨勢標準化分數': ['standardization', 'agricultural_population_proportion_trend'],
          '耕地面積標準化分數': ['standardization', 'cultivated_area'],
          '平均農業人口耕地面積標準化分數': ['standardization', 'average_agricultural_population_cultivated_area'],
          '市場成長相對強度標準化分數': ['standardization', 'market_growth_intensity'],
          '進口市場表現標準化分數': ['standardization', 'market_performance'],
          '市場開放程度標準化分數': ['standardization', 'market_openness'],
          '市場相對優惠關稅標準化分數': ['standardization', 'market_preferential_tariff'],
          '標準化分數總計': 'total_standardization',
          '標準化分數之世界排名': 'total_standardization_order',
          '目標市場國之產品進口值(千美元)': ['addition', 'partner_import_world_value'],
          '目標市場國之產品出口值(千美元)': ['addition', 'partner_export_world_value'],
          '目標市場國之產品前一年進口值(千美元)': ['addition', 'last_year_import_value'],
          '世界之產品進口值(千美元)': ['addition', 'world_import_world_value'],
          '前一年農業人口比率 (%)': ['addition', 'last_year_agricultural_population_proportion'],
          '人口數': 'total_population',
          '目標市場國之產品五年前進口值(千美元)': ['addition', 'last_5_year_partner_import_world_value'],
          '世界之產品五年前進口值(千美元)': ['addition', 'last_5_year_world_import_world_value'],
          '台灣出口目標市場國之產品出口值(千美元)': ['addition', 'taiwan_export_partner_value'],
          '台灣之產品出口值(千美元)': ['addition', 'taiwan_export_world_value'],
          '目標市場國之產品第一大進口國關稅(%)': ['addition', 'top_5_tariff', 0, data => data ? data.chinese_name + ':' + data.tariff : 'n/a'],
          '目標市場國之產品第二大進口國關稅(%)': ['addition', 'top_5_tariff', 1, data => data ? data.chinese_name + ':' + data.tariff : 'n/a'],
          '目標市場國之產品第三大進口國關稅(%)': ['addition', 'top_5_tariff', 2, data => data ? data.chinese_name + ':' + data.tariff : 'n/a'],
          '目標市場國之產品第四大進口國關稅(%)': ['addition', 'top_5_tariff', 3, data => data ? data.chinese_name + ':' + data.tariff : 'n/a'],
          '目標市場國之產品第五大進口國關稅(%)': ['addition', 'top_5_tariff', 4, data => data ? data.chinese_name + ':' + data.tariff : 'n/a'],
          '目標市場國對台灣之產品關稅': ['addition', 'partner_taiwan_tariff'],
          '目標市場國之產品出口量': ['addition', 'partner_export_world_quantity'],
          '目標市場國之產品出口量單位': ['addition', 'partner_export_world_quantity_unit'],
          '目標市場國之產品進口量': ['addition', 'partner_import_world_quantity'],
          '目標市場國之產品進口量單位': ['addition', 'partner_import_world_quantity_unit'],
          '世界之產品進口量(公噸)': ['addition', 'world_import_world_quantity'],
          '世界之產品出口值(千美元)': ['addition', 'world_export_world_value'],
          '世界之產品出口量(公噸)': ['addition', 'world_export_world_quantity']
        }
      }[this.analysisType]
      let csvContents = []
      let extraContents = []
      this.conditions.filters.product && extraContents.push('品項：' + this.getFilterTitle('product'))
      this.conditions.filters.country && extraContents.push('目標市場：' + this.getFilterTitle('country'))
      if (this.dataType === 'country') {
        this.conditions.filters.year && extraContents.push('數據年份：' + this.getFilterTitle('year'))
      } else if (this.dataType === 'year') {
        this.country && extraContents.push({
          competitiveness: '競爭國家：' + this.country.country_name,
          attraction: '市場國家：' + this.country.partner_name,
          toolcompetitiveness: '競爭國家：' + this.country.country_name,
          toolattraction: '市場國家：' + this.country.partner_name
        }[this.analysisType])
      }
      extraContents = [extraContents.join(', ')]
      csvContents.push(extraContents)
      let alertContents = []
      alertContents.push('原始資料與分析資料比較範圍不同會影響標準化分數數值，可能會造成排名略有差異。')
      csvContents.push(alertContents)
      let headerContents = Object.keys(dataOptions)
      csvContents.push(headerContents)
      for (let data of sortData(this.datas, { country: 'total_standardization', year: 'year' }[this.dataType], 'desc')) {
        csvContents.push(Object.values(dataOptions).map(value => {
          let paths = value.join ? value : [value]
          let content = data
          for (let path of paths) {
            content = path instanceof Function ? path(content) : content[path]
            if (!content) break
          }
          return content || content === 0 ? content : 'n/a'
        }))
      }
      let url = 'data:application/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csvContents.map(x => '"' + x.join('","') + '"').join('\r\n') + '\r\n')
      let title = ''
      title = title + {
        country: {
          competitiveness: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '的市場競爭力',
          attraction: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '各國市場吸引力',
          toolcompetitiveness: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '的農業機械市場競爭力',
          toolattraction: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '各國農業機械市場吸引力'
        },
        year: {
          competitiveness: this.getCountryTitle() + '的' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '市場的歷年市場競爭力',
          attraction: this.getFilterTitle('product') + '在' + this.getCountryTitle() + '的歷年市場吸引力',
          toolcompetitiveness: this.getCountryTitle() + '的' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '市場的歷年農業機械市場競爭力',
          toolattraction: this.getFilterTitle('product') + '在' + this.getCountryTitle() + '的歷年農業機械市場吸引力'
        }
      }[this.dataType][this.analysisType]
      title = title + '原始數據.csv'
      await this.sendDataAccessLog()
      downloadFile(title, url, '_target')
    },
    async sendDataAccessLog () {
      try {
        let config = this.$ls.get('userInfo')
        let type = {
          country: {
            competitiveness: 'market_competitiveness',
            attraction: 'market_attractiveness',
            toolcompetitiveness: 'market_competitiveness',
            toolattraction: 'market_attractiveness'
          },
          year: {
            competitiveness: 'single_country_market_competitiveness',
            attraction: 'single_country_market_attractiveness',
            toolcompetitiveness: 'single_country_market_competitiveness',
            toolattraction: 'single_country_market_attractiveness'
          }
        }[this.dataType][this.analysisType]
        let selectedDatas = this.selectedDatas.map(data => ({
          country: {
            competitiveness: data.country_name,
            attraction: data.partner_name,
            toolcompetitiveness: data.country_name,
            toolattraction: data.partner_name
          },
          year: {
            competitiveness: data.year,
            attraction: data.year,
            toolcompetitiveness: data.year,
            toolattraction: data.year
          }
        }[this.dataType][this.analysisType]))
        let paramDatas = {
          country: this.dataType === 'country' ? {
            competitiveness: {
              access_file_type: 'advanced_data_sheet',
              partner: this.conditions.filters.country,
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            attraction: {
              access_file_type: 'advanced_data_sheet',
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            toolcompetitiveness: {
              access_file_type: 'advanced_data_sheet',
              partner: this.conditions.filters.country,
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            toolattraction: {
              access_file_type: 'advanced_data_sheet',
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            }
          } : {},
          year: this.dataType === 'year' ? {
            competitiveness: {
              access_file_type: 'advanced_data_sheet',
              partner: this.conditions.filters.country,
              product_code: this.conditions.filters.product,
              country: this.country.country_code
            },
            attraction: {
              access_file_type: 'advanced_data_sheet',
              partner: this.country.partner_code,
              product_code: this.conditions.filters.product
            },
            toolcompetitiveness: {
              access_file_type: 'advanced_data_sheet',
              partner: this.conditions.filters.country,
              product_code: this.conditions.filters.product,
              country: this.country.country_code
            },
            toolattraction: {
              access_file_type: 'advanced_data_sheet',
              partner: this.country.partner_code,
              product_code: this.conditions.filters.product
            }
          } : {}
        }[this.dataType][this.analysisType]
        let data = {
          ...paramDatas,
          chart_params_info: selectedDatas.join(', ')
        }
        await postAccessLog(type, data, config)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    },
    async exportTable () {
      let csvContents = []
      let extraContents = []
      this.conditions.filters.product && extraContents.push('品項：' + this.getFilterTitle('product'))
      this.conditions.filters.country && extraContents.push('目標市場：' + this.getFilterTitle('country'))
      if (this.dataType === 'country') {
        this.conditions.filters.year && extraContents.push('數據年份：' + this.getFilterTitle('year'))
      } else if (this.dataType === 'year') {
        this.country && extraContents.push({
          competitiveness: '競爭國家：' + this.country.country_name,
          attraction: '市場國家：' + this.country.partner_name,
          toolcompetitiveness: '競爭國家：' + this.country.country_name,
          toolattraction: '市場國家：' + this.country.partner_name
        }[this.analysisType])
      }
      extraContents = [extraContents.join(', ')]
      csvContents.push(extraContents)
      let headerContents = []
      headerContents.push({
        country: this.tableOption.country.title,
        year: this.tableOption.year.title
      }[this.dataType])
      for (let content of this.tableOption.contents) {
        headerContents.push(content.title.join(''))
        let weighting = this.conditions.weightings[content.value].active ? this.conditions.weightings[content.value].value : 0
        headerContents.push(content.title.join('').replace(/\(.+\)/, '') + { country: '標準化分數(加權=' + weighting + ')', year: '之年度世界排名' }[this.dataType])
      }
      if (this.dataType === 'country') {
        headerContents.push('標準化分數總計')
        headerContents.push('標準化總分之世界排名')
      } else if (this.dataType === 'year') {
        headerContents.push('標準化總分之世界排名')
      }
      csvContents.push(headerContents)
      for (let [index, data] of Object.entries(this.tableDatas)) {
        if (this.selectedDatas.includes(data)) {
          let contents = []
          contents.push({
            country: data[this.tableOption.country.name] + '(' + data[this.tableOption.country.subName] + ')',
            year: data[this.tableOption.year.name]
          }[this.dataType])
          for (let content of this.tableOption.contents) {
            contents.push(data[content.value] || data[content.value] === 0 ? data[content.value].toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : 'n/a')
            contents.push({ country: (data.display_standardization[content.value] || 0).toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, ''), year: data.standardization[content.value + '_order'] }[this.dataType])
          }
          if (this.dataType === 'country') {
            contents.push(data.display_total_standardization || 0)
            contents.push(index - -1)
          } else if (this.dataType === 'year') {
            contents.push(data.total_standardization_order || 'n/a')
          }
          csvContents.push(contents)
        }
      }
      let url = 'data:application/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csvContents.map(x => '"' + x.join('","') + '"').join('\r\n') + '\r\n')
      let title = ''
      title = title + {
        country: {
          competitiveness: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '的市場競爭力',
          attraction: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '各國市場吸引力',
          toolcompetitiveness: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '的農業機械市場競爭力',
          toolattraction: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '各國農業機械市場吸引力'
        },
        year: {
          competitiveness: this.getCountryTitle() + '的' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '市場的歷年市場競爭力',
          attraction: this.getFilterTitle('product') + '在' + this.getCountryTitle() + '的歷年市場吸引力',
          toolcompetitiveness: this.getCountryTitle() + '的' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '市場的歷年農業機械市場競爭力',
          toolattraction: this.getFilterTitle('product') + '在' + this.getCountryTitle() + '的歷年農業機械市場吸引力'
        }
      }[this.dataType][this.analysisType]
      title = title + '分析表.csv'
      await this.sendTableAccessLog()
      downloadFile(title, url, '_target')
    },
    async sendTableAccessLog () {
      try {
        let config = this.$ls.get('userInfo')
        let type = {
          country: {
            competitiveness: 'market_competitiveness',
            attraction: 'market_attractiveness',
            toolcompetitiveness: 'market_competitiveness',
            toolattraction: 'market_attractiveness'
          },
          year: {
            competitiveness: 'single_country_market_competitiveness',
            attraction: 'single_country_market_attractiveness',
            toolcompetitiveness: 'single_country_market_competitiveness',
            toolattraction: 'single_country_market_attractiveness'
          }
        }[this.dataType][this.analysisType]
        let selectedDatas = this.selectedDatas.map(data => ({
          country: {
            competitiveness: data.country_name,
            attraction: data.partner_name,
            toolcompetitiveness: data.country_name,
            toolattraction: data.partner_name
          },
          year: {
            competitiveness: data.year,
            attraction: data.year,
            toolcompetitiveness: data.year,
            toolattraction: data.year
          }
        }[this.dataType][this.analysisType]))
        let paramDatas = {
          country: this.dataType === 'country' ? {
            competitiveness: {
              access_file_type: 'normal_data_sheet',
              partner: this.conditions.filters.country,
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            attraction: {
              access_file_type: 'normal_data_sheet',
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            toolcompetitiveness: {
              access_file_type: 'normal_data_sheet',
              partner: this.conditions.filters.country,
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            toolattraction: {
              access_file_type: 'normal_data_sheet',
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            }
          } : {},
          year: this.dataType === 'year' ? {
            competitiveness: {
              access_file_type: 'normal_data_sheet',
              partner: this.conditions.filters.country,
              product_code: this.conditions.filters.product,
              country: this.country.country_code
            },
            attraction: {
              access_file_type: 'normal_data_sheet',
              partner: this.country.partner_code,
              product_code: this.conditions.filters.product
            },
            toolcompetitiveness: {
              access_file_type: 'normal_data_sheet',
              partner: this.conditions.filters.country,
              product_code: this.conditions.filters.product,
              country: this.country.country_code
            },
            toolattraction: {
              access_file_type: 'normal_data_sheet',
              partner: this.country.partner_code,
              product_code: this.conditions.filters.product
            }
          } : {}
        }[this.dataType][this.analysisType]
        let paramInfos = Object.entries(this.conditions.weightings).map(([value, condition]) => [
          condition.title,
          condition.active ? condition.value : 0
        ])
        let data = {
          ...paramDatas,
          chart_params_info: selectedDatas.join(', '),
          weighted_index_info: paramInfos.map(info => info.join(' = ')).join(', ')
        }
        await postAccessLog(type, data, config)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/analysis/table.vue